/*
 * @Author: zhaoyu zhaoy@normstar.com
 * @Date: 2024-05-07 11:56:06
 * @LastEditors: zhaoyu zhaoy@normstar.com
 * @LastEditTime: 2024-08-26 09:27:01
 * @FilePath: \ns-web-management\src\hooks\useEnv.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export function useEnv() {
  function getProject() {
    return import.meta.env.VITE_APP_PROJECT
  }

  function getInternationalization() {
    return import.meta.env.VITE_IS_INTERNATIONALIZATION_ENABLED
  }
  return {
    projectName: getProject(),
    // 是否南航项目
    isNhxm: getProject() === 'nhxm',
    // 是否中核项目
    isZhxm: getProject() === 'zhxm',
    // 是否开启国际化
    isInternationalizationEnabled: getInternationalization() === 'true'
  }
}
